"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Atoms_1 = require("../../Atoms");
const S = __importStar(require("./Balance.styles"));
exports.default = (props) => {
    const { visible, enabled, balance = 0, chargeText } = props;
    if (!visible || !enabled)
        return null;
    return (react_1.default.createElement(S.UpperViewContainer, null,
        react_1.default.createElement(S.AmountText, null,
            "\u00A3",
            balance),
        react_1.default.createElement(S.CreditText, null, chargeText),
        react_1.default.createElement(Atoms_1.Spacer, { vSpace: 48 })));
};
